import React from 'react'
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';

const About = () => {
  return (
    <Box>
      <Box sx= {{ margin: '20px 12px', color: '#FFFFFF' }}>
          <Typography sx={{ fontFamily: 'Merriweather', fontWeight: 700, fontSize: 18}}>
              About
          </Typography>
          <Divider sx={{ backgroundColor: '#FFFFFF', width: '30px', height: '2px' }} />
          <Typography sx={{ fontFamily: 'Merriweather',  fontSize: 14, letterSpacing: '0.4px', marginTop: '7px' }}>
            Application Developer with a year of hands-on experience in developing and deploying production-ready web projects. Proficient in utilizing diverse technology stacks, including Ruby on Rails (v5 & v7), JavaScript (jQuery, Stimulus JS), Vanilla PHP, MySQL, and Source Control tools like Gitlab & Github. Committed to delivering innovative solutions that drive user engagement and business growth. 
          </Typography>
      </Box>
    </Box>
  )
}

export default About